import axiosInstance from '../utils/axiosInstance';
import type { Note, NoteAttachmentInput } from '../../types/note';

interface NoteResponse {
  success: boolean;
  data: { note: Note };
}

interface NotesResponse {
  success: boolean;
  data: { notes: Note[] };
}

export const createNote = async (
  matterId: string,
  body: string,
  attachments: NoteAttachmentInput[] = [],
): Promise<Note> => {
  const res = await axiosInstance.post<NoteResponse>(
    `/matters/${matterId}/notes`,
    { body, attachments },
  );
  return res.data.data.note;
};

export const listNotesForMatter = async (matterId: string): Promise<Note[]> => {
  const res = await axiosInstance.get<NotesResponse>(`/matters/${matterId}/notes`);
  return res.data.data.notes;
};

export const deleteNote = async (
  matterId: string,
  noteId: string,
): Promise<void> => {
  await axiosInstance.delete(`/matters/${matterId}/notes/${noteId}`);
};
